<template>
  <FKBreadCrumb :page="$t('page.system_users')" />
  <SystemUsersList />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import SystemUsersList from "@/components/FK/UsersList/SystemUsersList.vue";

export default defineComponent({
  name: "SystemUsersPage",
  components: {
    FKBreadCrumb,
    SystemUsersList,
  },
});
</script>